export class BikeRack {
    static fromExistingData(data: any): BikeRack {
        const bikeRack = new BikeRack();
        if (data.id) bikeRack.id = data.id;
        if (data.rackNumber) bikeRack.rackNumber = data.rackNumber;
        if (data.rentedOut) bikeRack.rentedOut = data.rentedOut ? 1 : 0;
        if (data.rentedTo) bikeRack.rentedTo = data.rentedTo;
        if (data.extendedRentedTo)
            bikeRack.extendedRentedTo = {
                building: data.extendedRentedTo.building ? data.extendedRentedTo.building.id : undefined,
                buildingName: data.extendedRentedTo.building ? data.extendedRentedTo.building.name : undefined,
                suite: data.extendedRentedTo.suite ? (data.extendedRentedTo.suite.id || 0) : undefined,
                suiteNumber: data.extendedRentedTo.suite ? (data.extendedRentedTo.suite.suiteNumber) : undefined,
                suiteUser: data.extendedRentedTo.suiteUser ? (data.extendedRentedTo.suiteUser.id || 0) : undefined,
                suiteUserName: data.extendedRentedTo.suiteUser ? (data.extendedRentedTo.suiteUser.user.fullName) : undefined,
            };
        if (data.note) bikeRack.note = data.note;

        if (data.suite) bikeRack.suiteId = data.suite.id;
        if (data.suite) bikeRack.suiteNumber = data.suite.suiteNumber;
        if (data.building) bikeRack.buildingId = data.building.id;
        if (data.building) bikeRack.buildingName = data.building.name;
        bikeRack.isCanEdit = data.isCanEdit;
        bikeRack.isCanDelete = data.isCanDelete;
        return bikeRack;
    }

    constructor(
        public id: number = null,
        public rackNumber: string = '',
        public rentedOut: number = 0,
        public rentedTo: string = '',
        public extendedRentedTo: any = {},
        public note: string = '',
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            rackNumber: {editMode: false},
            rentedOut: {editMode: false},
            rentedTo: {editMode: false},
            rentedToBuilding: {editMode: false},
            rentedToSuite: {editMode: false},
            rentedToSuiteUser: {editMode: false},
            note: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/BikeRack.ts